import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import CalculatorComponent from '../../components/Entity/Cars/Calculator/Calculator';

const CalculatorPage = () => {
  return <Layout > 
       <CalculatorComponent isArchive={false} isDelete={false} ></CalculatorComponent>  
  </Layout>;
}

export default CalculatorPage;